import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { increment, decrement, recovery } from '../../store/Font/Font.actions';
import { PopupOverlay, PopupContainer, CloseButton, OptionsContainer, Option, AccessibilityButton, } from './styles';

interface AccessibilityPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AccessibilityPopup({ isOpen, onClose }: AccessibilityPopupProps) {
  const dispatch = useDispatch();

  if (!isOpen) return null;

  return (
    <PopupOverlay onClick={onClose}>
      <PopupContainer onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        
        <OptionsContainer>
          
               <AccessibilityButton
                    type="button"
                    id="btnAumentar"
                    onClick={() => dispatch(increment())}
                    tabIndex={2}
                >
                A+
                </AccessibilityButton>
                <AccessibilityButton type="button" onClick={() => dispatch(recovery())} tabIndex={2}>
                A 
                </AccessibilityButton>
              
                <AccessibilityButton
                    type="button"
                    id="btnDiminuir"
                    onClick={() => dispatch(decrement())}
                    tabIndex={2}
                >
                A-
                </AccessibilityButton> 
          
          
        </OptionsContainer>
      </PopupContainer>
    </PopupOverlay>
  );
}
